import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  const { lang } = useLanguage();

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-[#FAF7F2] px-4 py-20">
      <SEO title={lang === 'da' ? '404 Siden blev ikke fundet' : '404 Page Not Found'} />
      <div className="text-center max-w-md space-y-6">
        <span className="font-serif-display text-7xl font-bold text-[#2E3191]">404</span>
        <h1 className="font-serif-display text-3xl font-bold text-[#2C2825]">
          {lang === 'da' ? 'Siden blev ikke fundet' : 'Page Not Found'}
        </h1>
        <p className="text-sm text-[#6E6760] leading-relaxed">
          {lang === 'da'
            ? 'Beklager, den side du leder efter, eksisterer ikke eller er blevet flyttet.'
            : 'Sorry, the page you are looking for does not exist or has been moved.'}
        </p>
        <div>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#2E3191] text-white text-sm font-semibold hover:bg-[#1E2063] transition-all"
          >
            <i className="fa-solid fa-house text-xs" />
            {lang === 'da' ? 'Gå til forsiden' : 'Return Home'}
          </Link>
        </div>
      </div>
    </div>
  );
}
